import React from 'react';

import { EventForUser } from '../../types';
import ManageEvent from './ManageEvent';
import GuestEventOptions from './GuestEventOptions';

type EventMenuProps = {
  event: EventForUser;
  onClickGuestPreview: () => void;
  toggleCheckout: () => void;
  onClickViewShareOptions: () => void;
  toggleManageEvent: () => void;
  onClickViewContactsModal: () => void;
  visible: boolean;
  isLoggedIn: boolean;
};

const EventMenu: React.FC<EventMenuProps> = ({
  event,
  onClickGuestPreview,
  onClickViewShareOptions,
  onClickViewContactsModal,
  toggleManageEvent,
  toggleCheckout,
  visible,
  isLoggedIn
}) =>
  event.isOrganizer || event.isScanner || event.isPhotographer ? (
    <ManageEvent
      event={event}
      onClickGuestPreview={onClickGuestPreview}
      onClickViewShareOptions={onClickViewShareOptions}
      toggleManageEvent={toggleManageEvent}
      visible={visible}
    />
  ) : (
    <GuestEventOptions
      event={event}
      toggleCheckout={toggleCheckout}
      onClickViewShareOptions={onClickViewShareOptions}
      onClickViewContactsModal={onClickViewContactsModal}
      toggleManageEvent={toggleManageEvent}
      visible={visible}
      isLoggedIn={isLoggedIn}
    />
  );

export default EventMenu;
